import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LocalizationContext } from '../App';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { BrowserView, MobileView, isDesktop, isMobile } from 'react-device-detect';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { alpha, styled } from '@mui/material/styles';
import env from "react-dotenv";
import { ReactSession } from 'react-client-session';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import QrCodeIcon from '@mui/icons-material/QrCode';
import TagIcon from '@mui/icons-material/Tag';
import axios from 'axios';
import Alert from '@mui/material/Alert';
import { useMediaQuery } from 'react-responsive';



function LoupeHome(props) {

    ReactSession.setStoreType("localStorage");

    const isMobileViewWidth = useMediaQuery({
        query: '(max-width: 900px)'
      })

    const navigate = useNavigate();

    const theme = props.theme;
    const uploadCallbackHandler = props.uploadCallback;

    const bg = (theme == 'light') ? "#ffffff66" : "#12121266";
    const imprintAddress = process.env.REACT_APP_IMPRINT_ADDRESS;

    const [ codeHasError, setCodeHasError ]= React.useState(false); 

    const handleClose = () => {
        setCodeHasError(false);
      };

    const ColorButton = styled(Button)({
        color: '#ffffff',
        padding : '15px',
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: '#777777',
        },
      });

    const [ code, setCode ] = useState("");

    const openActivity = () => {     
        submitCode();
    }
    const handleChange = (event) => {        
        setCode(event.target.value);
    }
    const handleKeyUp = (event) => {
        if(event.keyCode == 13) {
            submitCode();
        }
    }

    var cTime = "day";
    const currentD = new Date();
    
    const morning = new Date();
    morning.setHours(6,0,0); 
    const noon = new Date();
    noon.setHours(12,0,0);
    const evening = new Date();
    evening.setHours(18,0,0);
    const night = new Date();
    night.setHours(23,0,0);

    if(currentD >= morning && currentD < noon ) {
        cTime = "morning";
    } else if(currentD >= noon && currentD < evening) {
        cTime = "afternoon";
    } else if(currentD >= evening && currentD < night) {
        cTime = "evening";
    } else if(currentD >= night && currentD < morning) {
        cTime = "night";
    }
    

    const submitCode = () => {
        if(code == "") {
            setCodeHasError(true);
        } else {
            retrieveIsValidActivity(code);
        }  
    }

    const retrieveIsValidActivity = (code) => {

        let uri = process.env.REACT_APP_SERVICE_URI + '/api/isValidCode/' + code;      
        axios.get(uri, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                'LOUPE-USR-KEY' : ReactSession.get("userid"),
                'LOUPE-API-KEY' : 'APIKEY2',
            }
        }).then(res => { 
            if(res.data == 'TRUE') {                
                navigate('/start/' + code, { replace : true } );
            } else {
                setCodeHasError(true);
            }   

        }).catch(error => {
            console.log(error);
        });
    }

    const [ hasPreviousData, setHasPreviousData ] = React.useState(false); 
    const updatePrevDataState = () => {
        var prevData = JSON.parse(ReactSession.get("prevSessionStore"));
        var nrKeys = Object.keys(prevData).length;
        if( nrKeys > 0 ) {
            setHasPreviousData(true);
        } else {
            setHasPreviousData(false);
        }
    }

    useEffect(() => {        
        updatePrevDataState();  
    }, []);

    
    return (
        <LocalizationContext.Consumer>

            { ({strings}) =>
                
                <Paper className="padding">                               
                   
                    <div className="container padding">

                        <Typography variant="h5" gutterBottom component="div">{strings.getString("texts.time." + cTime)}</Typography>                        
                        <Divider className="tbm" />

                        <Grid container>

                            <Grid item xs={12} md={5}>
                                <Typography style={{textAlign : isMobileViewWidth ? "center" : "left" }} variant="body1" gutterBottom component="div">{strings.getString("texts.introduction")}</Typography>                           
                         
                                <div className="tbm">
                                    { isDesktop && 
                                        <>
                                            <Button onClick={() => navigate('/about', { replace : true })}>{strings.getString("controls.buttons.learnmore")}</Button>
                                            <Button onClick={() => navigate('/activities-here', { replace : true })}>{strings.getString("controls.buttons.activity.local")}</Button>
                                        </>
                                    }
                                </div>                                
                            </Grid>

                            <Grid item xs={12} md={1}>
                                <p />                               
                            </Grid>

                            <Grid item xs={12} md={6}>

                                { hasPreviousData && 
                                    <>
                                        <Alert severity="warning" className={ isMobileViewWidth ? "mb-5" : "mb-4" }>
                                            <p>
                                                {strings.getString("texts.activity.forupload")}
                                            </p>
                                            <Button color="secondary" onClick={() => {uploadCallbackHandler(true)}}>{strings.getString("controls.buttons.upload")}</Button>
                                            
                                        </Alert>
                                    </>
                                }


                                <Paper className="loupe-gradient padding mb-8">
                                    <Grid container>
                                        <Grid item xs="auto">
                                            <TagIcon className="text-white"/>
                                        </Grid>
                                        <Grid item xs={1} />
                                        <Grid item xs>
                                            <Typography className="text-start text-white mb-4" variant="body2" gutterBottom component="div">
                                                { isMobile == true ? 
                                                    (strings.getString("texts.entercode_mobile")) : (strings.getString("texts.entercode"))
                                                }
                                            </Typography>                                    
                                        </Grid>
                                    </Grid>
                                    
                                    <div style={{background : bg, padding : 10, borderRadius : 5}} className="mb-4 step-here">
                                        <div className="e-float-input">
                                            <input type="text" onInput={handleChange} onKeyUp={handleKeyUp} />
                                            <span className="e-float-line"/>
                                            <label className="e-float-text text-white">CODE</label>
                                        </div>
                                    </div>
                                    
                                    <ColorButton onClick={() => openActivity()} size="small">{strings.getString("controls.buttons.activity.open")}</ColorButton>
                                    
                                    { isMobile == true && 
                                        <ColorButton onClick={() => navigate('/scan', { replace : true })} size="small">
                                            <QrCodeIcon />
                                        </ColorButton>
                                    }

                                </Paper>


                                
                                
                               
                            </Grid>



                        </Grid>
                        <Typography gutterBottom component="div" variant="caption">App-Version {process.env.REACT_APP_VERSION}</Typography>

                    </div>

                    <Dialog
                        open={codeHasError}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">

                        <DialogTitle id="alert-dialog-title">
                        { strings.getString("errors.emptycode.title") }
                        </DialogTitle>
                        <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            { strings.getString("errors.emptycode.message") }
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleClose} autoFocus>
                            OK
                        </Button>
                        </DialogActions>
                    </Dialog>
            
                </Paper>  

            }

        </LocalizationContext.Consumer>
       
    );
}

export default LoupeHome;